import { useNavigate } from "react-router-dom";
import RegularButton from "../../components/Buttons/RegularButton";
import Header from "../../components/Header/Header";
import { BsFillEmojiFrownFill } from "react-icons/bs";

function PaymentCancel() {
  const navigate = useNavigate();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const userToken: string = currentUser?.jwtToken;
  const orderId: any = JSON.parse(localStorage.getItem("orderId") || "{}");
  return (
    <div className="overscroll-x-none">
      <div className="h-[75px] z-10 fixed mx-10 ">
        <Header position={"fixed"} isLoggedIn={userToken ? true : false} />
      </div>

      <div className="mx-[200px] my-[150px] ">
        <div
          className=" justify-center  rounded-[4px]  h-[20%]  shadow-2xl "
          style={{
            overflow: "hidden",
            marginBottom: 10,
            zIndex: -1,
            backgroundColor: "white",
          }}
        >
          <div className="justify-between items-center flex flex-col  ">
            <h5 className="text-3xl pt-4 mr-8 ml-8">
              Your booking is not successful due to payment failure. If any
              amount is debited will be credit back to your account within 5-7
              business days.
            </h5>
            <h5 className="text-3xl pt-4  mr-8 ml-8 mb-8">
              Please use the Transaction ID: {orderId} for your reference.
              Thanks
            </h5>
            <RegularButton
              onClick={() => {
                navigate("/");
              }}
              className=" md:w-[30%] p-4 m-2"
              title={"Go home"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancel;
